<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3 page-title">
            <h3 class="text-center mt-2 mal-text custom-title">സമർപ്പിച്ച അപേക്ഷകൾ</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section pt-1" v-else>
        <p class="sneha-page-note mal-text" v-if="applications.length">
            ഈ ശാഖയിൽ സമർപ്പിച്ച അപേക്ഷകൾ ({{ applications.length }})
        </p>

        <div v-if="!applications.length" class="sneha-empty-apps mal-text">
            ഇതുവരെ അപേക്ഷകൾ ഇല്ല.
        </div>

        <div v-else class="sneha-app-list">
            <router-link
                v-for="app in applications"
                :key="app.id"
                :to="applicationDetailPath(app.id)"
                class="sneha-app-item"
            >
                <div class="sneha-app-main">
                    <span class="sneha-app-name mal-text">{{ app.name }}</span>
                    <span class="sneha-app-program mal-text">{{ app.program_title }}</span>
                    <span class="sneha-app-meta mal-text" v-if="app.contact">ഫോൺ: {{ app.contact }}</span>
                    <span class="sneha-app-meta mal-text" v-if="app.created_at">തീയതി: {{ app.created_at }}</span>
                </div>
                <ion-icon name="chevron-forward-outline" class="sneha-app-chevron"></ion-icon>
            </router-link>
        </div>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
    name: "SnehaSparshamApplicationList",
    data() {
        return {
            loading: true,
            applications: [],
        };
    },
    mounted() {
        this.$root.updateParent("സമർപ്പിച്ച അപേക്ഷകൾ");
        this.loadApplications();
    },
    activated() {
        this.loadApplications();
    },
    methods: {
        applicationDetailPath(applicationId) {
            return `/org/${this.$route.params.sub_level}/${this.$route.params.id}/sneha-sparsham-application/${applicationId}`;
        },
        loadApplications() {
            const unitId = parseInt(this.$route.params.id, 10);
            if (!unitId) {
                this.applications = [];
                this.loading = false;
                return;
            }

            this.loading = true;
            UserService.authPostRequest("get-sneha-sparsham-report", {
                user_level: 4,
                user_level_id: unitId,
            }).then((res) => {
                if (res.data.status === "success") {
                    this.applications = res.data.data.list || [];
                } else {
                    this.applications = [];
                }
            }).catch(() => {
                this.applications = [];
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
</script>

<style scoped>
.sneha-page-note {
    margin: 0 0 14px;
    padding: 0 4px;
    font-size: 0.9rem;
    color: #6c757d;
    line-height: 1.45;
}

.sneha-empty-apps {
    text-align: center;
    padding: 24px 12px;
    color: #6c757d;
    font-size: 0.92rem;
    background: #fff;
    border-radius: 10px;
    border: 1px dashed #ced4da;
}

.sneha-app-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sneha-app-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    text-decoration: none;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    transition: background-color 0.15s ease;
}

.sneha-app-item:active {
    background: #f8f9fa;
}

.sneha-app-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}

.sneha-app-name {
    font-size: 0.98rem;
    font-weight: 600;
    color: #1a418c;
    line-height: 1.35;
    word-break: break-word;
}

.sneha-app-program {
    font-size: 0.86rem;
    color: #6c757d;
    line-height: 1.35;
}

.sneha-app-meta {
    font-size: 0.82rem;
    color: #495057;
    line-height: 1.35;
}

.sneha-app-chevron {
    flex-shrink: 0;
    font-size: 20px;
    color: #adb5bd;
}
</style>
